// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

import ReactOnRails from "react-on-rails";
import OrganizationEvents from "../bundles/OrganizationEvents";
import CustomizeLandingPage from "../bundles/OrganizationEvents/CustomizeLandingPage";

// This is how react_on_rails can see the OrganizationEvents in the browser.
ReactOnRails.register({
  OrganizationEvents
});
ReactOnRails.register({
  CustomizeLandingPage
});
